import { render } from "./NearbyListItem.vue?vue&type=template&id=47e4133a&scoped=true"
import script from "./NearbyListItem.vue?vue&type=script&lang=js"
export * from "./NearbyListItem.vue?vue&type=script&lang=js"

import "./NearbyListItem.vue?vue&type=style&index=0&id=47e4133a&scoped=true&lang=css"

import exportComponent from "/Users/klausdresbach/Dropbox/IT-Projekte/Web-Entwicklung/niceplaces/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47e4133a"]])

export default __exports__